import { render } from "./ImportUnmanagedInstance.vue?vue&type=template&id=48eb77b0"
import script from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"
export * from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"

import "./ImportUnmanagedInstance.vue?vue&type=style&index=0&id=48eb77b0&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__